class ProductForm extends HTMLElement {
    constructor() {
        super();   
        this.form = this.querySelector('form');
        if (this.form) {
            this.form.addEventListener('submit', this.onSubmitHandler.bind(this), true);
        }
    }

    onSubmitHandler(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
    
        const submitter = evt.submitter;
        const isBuyNow = !!(
            submitter && (
                submitter.name === 'checkout' ||
                submitter.hasAttribute('data-buy-now') ||
                submitter.classList.contains('shopify-payment-button__button') ||
                (submitter.closest && (submitter.closest('.shopify-payment-button') || submitter.closest('.productView-payment')))
            )
        );

        const submitButton = submitter || this.querySelector('[type="submit"][name="add"]') || this.querySelector('[type="submit"]');
        
        if (!submitButton || !this.form) {
            console.error('ProductForm: Form or submit button not found');
            return;
        }

        submitButton.setAttribute('disabled', true);
        submitButton.classList.add('loading');
        
        const originalButtonText = submitButton.textContent;
        submitButton.textContent = isBuyNow ? 'Redirecting...' : 'Adding to cart...';

        try {
            const formData = new FormData(this.form);
            const variantId = formData.get('id');
            const quantity = parseInt(formData.get('quantity') || '1', 10);
            
            const payload = {
                id: variantId,
                quantity: quantity
            };

            const properties = {};
            for (let [key, val] of formData.entries()) {
                if (key.startsWith('properties[')) {
                    const propKey = key.replace('properties[', '').replace(']', '');
                    properties[propKey] = val;
                }
            }
            if (Object.keys(properties).length > 0) {
                payload.properties = properties;
            }

            const body = JSON.stringify(payload);
            const cartAddUrl = (typeof routes !== 'undefined' && routes.cart_add_url) ? routes.cart_add_url : '/cart/add.js';

            fetch(`${cartAddUrl}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: body
            })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                if (data.status && data.status !== 'ok') {
                    this.handleErrorMessage(data.description || 'Unable to add item to cart');
                    submitButton.classList.remove('loading');
                    submitButton.removeAttribute('disabled');
                    submitButton.textContent = originalButtonText;
                    return;
                }

                if (isBuyNow) {
                    const checkoutUrl = (typeof window.routes !== 'undefined' && window.routes.cart_url ? window.routes.cart_url : '/cart') + '/checkout';
                    window.location.href = checkoutUrl;
                } else {
                    this.showSuccessMessage('Added to cart!');
                    if (typeof Shopify !== 'undefined' && Shopify.getCart) {
                        Shopify.getCart((cart) => {
                            this.handleCartUpdate(cart);
                        });
                    } else {
                        this.handleCartUpdate(null);
                    }
                    submitButton.classList.remove('loading');
                    submitButton.removeAttribute('disabled');
                    submitButton.textContent = originalButtonText;
                }
            })
            .catch((error) => {
                console.error('ProductForm AJAX Error:', error);
                this.handleErrorMessage('Error adding item to cart. Please try again.');
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('disabled');
                submitButton.textContent = originalButtonText;
            });
        } catch (error) {
            console.error('ProductForm Exception:', error);
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('disabled');
            submitButton.textContent = originalButtonText;
            this.handleErrorMessage('Error processing your request');
        }
    }

    handleCartUpdate(cart) {
        // Sync cart count if available
        if (window.halo && typeof window.halo.syncCartCount === 'function' && cart) {
            window.halo.syncCartCount(cart);
        }
        
        // Always open CQC drawer after add-to-cart
        if (window.CQC && typeof window.CQC.open === 'function') {
            window.CQC.open();
        }
        
        const overlay = document.querySelector('.background-overlay');
        if (overlay) overlay.classList.remove('hold');
    }

    showSuccessMessage(message) {
        // Display temporary success message (can be customized)
        const notification = document.createElement('div');
        notification.className = 'product-form__success-notification';
        notification.textContent = message;
        notification.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            background: #4CAF50;
            color: white;
            padding: 15px 20px;
            border-radius: 4px;
            z-index: 9999;
            animation: slideIn 0.3s ease-in;
        `;
        
        document.body.appendChild(notification);
        
        setTimeout(() => {
            notification.style.animation = 'slideOut 0.3s ease-out';
            setTimeout(() => notification.remove(), 300);
        }, 2000);
    }

    handleErrorMessage(errorMessage = false) {
        const errorWrapper = this.querySelector('.product-form__error-message-wrapper');
        if (!errorWrapper) return;
        
        const errorElement = errorWrapper.querySelector('.product-form__error-message');
        if (!errorElement) return;

        errorWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
            errorElement.textContent = errorMessage;
        }
    }
}

customElements.define('product-form', ProductForm);
